export const MAX_TICKET_DESCS_LENGTH = 2000;
export const FILTERS_LOCALSTORAGE_KEY = 'HOME_FILTERS';
